import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { UitkLayoutFlexDirection, UitkLayoutFlexItemGrow } from 'uitk-react-layout-flex/dist/types';

import { UitkLayoutFlex, UitkLayoutFlexItem, UitkLayoutFlexItemProps } from 'uitk-react-layout-flex';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

import { z } from 'zod';

export const UitkComponent: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;
  const configSchema = z.optional(
    z.object({
      type: z.string(),
      grow: z.optional(z.number()),
      direction: z.optional(z.string()),
      colSpan: z.optional(z.number()),
      padding: z.optional(z.any()),
      margin: z.optional(z.any()),
      maxWidth: z.optional(z.union([z.string(), z.number()])),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success || !children || children.length === 0) {
    return null;
  }

  const { type, grow, direction, colSpan, padding, margin, maxWidth } = result.data ?? {};

  const templateRenderer = <ExperienceTemplateRenderer templateComponents={children} />;

  switch (type) {
    case 'UitkLayoutFlex':
      return <UitkLayoutFlex direction={direction as UitkLayoutFlexDirection}>{templateRenderer}</UitkLayoutFlex>;
    case 'UitkLayoutFlexItem':
      return (
        <UitkLayoutFlexItem grow={grow as UitkLayoutFlexItemGrow} maxWidth={maxWidth as UitkLayoutFlexItemProps['maxWidth']}>
          <div>{templateRenderer}</div>
        </UitkLayoutFlexItem>
      );
    case 'UitkLayoutGridItem':
      return (
        <UitkLayoutGridItem colSpan={colSpan}>
          <div>{templateRenderer}</div>
        </UitkLayoutGridItem>
      );
    case 'UitkSpacing':
      return (
        <UitkSpacing padding={padding} margin={margin}>
          <div>{templateRenderer}</div>
        </UitkSpacing>
      );
    default:
      return null;
  }
};
